import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

interface State {
  hasError?: boolean;
}

class ErrorBoundary extends Component<any, State> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: any, errorInfo: React.ErrorInfo) {
    const { history } = this.props;
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    console.error('Error stack:', error.stack);
    console.error('Component stack:', errorInfo.componentStack);
    this.setState({ hasError: true });
    // Temporarily disable redirect to see the actual error
    // history.push({ pathname: '/error', state: { hasError: true } });
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }
    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);